import { RootState } from '../../../rootReducer';
import { IChartsState } from './types';

export const selectDashboardCharts = (state: RootState): IChartsState =>
  state.dashboard.charts;
